import { Component, OnInit, Input  } from '@angular/core';
import { PayPal, PayPalPayment, PayPalConfiguration } from '@ionic-native/paypal/ngx';
import { ModalController } from '@ionic/angular';
import { DeudaService } from 'src/app/services/deuda.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-paypal-web',
  templateUrl: './paypal-web.page.html',
  styleUrls: ['./paypal-web.page.scss'],
})

export class PaypalWebPage implements OnInit {

@Input() importeAPagar;
@Input() datos;

//private Sandbox_account: 'sb-5f1bi2681888@business.example.com'
//private Client_ID: 'AR7MkkoYqDpMwmzfZD583ZvUwFhci10IlV6P7W54q1jinYSK4QNJQ0uq0p-Zb3x405fCy-4RfXB50EOz'
private Sandbox_account
private Client_ID

paymentAmount: string = '3.33';
currency: string = 'EUR';
currencyIcon: string = '€';
  constructor(
    private payPal: PayPal,
    public modalCtrl: ModalController,
    private deudaSrv: DeudaService,
    ) {
    let _this = this;
    setTimeout(() => {
      // Render the PayPal button into #paypal-button-container
      <any>window['paypal'].Buttons({

        // Set up the transaction
        createOrder: function (data, actions) {
          return actions.order.create({
            purchase_units: [{
              amount: {
                value: _this.paymentAmount
              }
            }]
          });
        },

        // Finalize the transaction
        onApprove: function (data, actions) {
          return actions.order.capture()
            .then(function (details) {
              console.log(details);
              // Show a success message to the buyer
              _this.cerrar("SUCCESS");
            })
            .catch(err => {
              console.log(err);
            })
        },
        onError: function (data) {
          
          _this.cerrar("ERROR");
        },
        onCancel: function (data, actions) {
          return actions.order.capture()
            .then(function (details) {
              console.log(details);
              // Show a success message to the buyer
              _this.cerrar("CANCEL");
            })
            .catch(err => {
              console.log(err);
            })
        }
      }).render('#paypal-button-container');
    }, 500)
  }
  async ngOnInit() {
    this.paymentAmount = this.importeAPagar;

    this.Sandbox_account = await this.deudaSrv.getSandbox_account();
    this.Sandbox_account = this.Sandbox_account.sandbox;
    this.Client_ID = await this.deudaSrv.getClient_ID();
    this.Client_ID = this.Client_ID.client
    console.log(this.Sandbox_account)
    console.log(this.Client_ID)
    
  }

  cerrar(data)
  {
    
    
    this.modalCtrl.dismiss(data);
  }

}
